import _ from 'lodash';

import {
	INITIALISE_STORE, ERROR, LOGGED_USER, LOAD_STATE, RESET,
} from './actionTypes';
import { LOCALSTORAGE_STATE_KEY } from './constants';
import { storesMap } from './registry';
import { TABLE_DATA_EXPORT } from './listEditTypes';

export const mutations = {
	[INITIALISE_STORE]: (state) => {
		state.authorization.init && state.authorization.init();
	},
	[ERROR]: (state, { moduleKey, stateKey, err }) => {
		if (moduleKey && stateKey) {
			state[moduleKey][stateKey].status = ERROR;
		}
		console.error(err);
	},
	[LOGGED_USER]: (state, payload) => {
		state.loggedUser = payload;
	},
	[RESET](state, { storeModule, storeObject }) {
		if (!state[storeModule]) { return; }
		if (!state[storeModule][storeObject]) { return; }
		const initState = _.cloneDeep(state[storeModule][storeObject].Init);
		_.assign(state[storeModule][storeObject], initState);
	},
	[TABLE_DATA_EXPORT](state, { storeModule, storeObject }) {
		if (!state[storeModule]) { return; }
		if (!state[storeModule][storeObject]) { return; }
		console.log(state[storeModule][storeObject]);
	},
	[LOAD_STATE](state) {
		const savedStateJson = window.localStorage.getItem(LOCALSTORAGE_STATE_KEY);

		if (!savedStateJson) return;

		window.localStorage.removeItem(LOCALSTORAGE_STATE_KEY);

		const savedState = JSON.parse(savedStateJson);
		const { pages } = savedState;

		savedState.pages = {};
		_.assign(state, savedState);

		savedState.pageManager.pages.forEach(({ storeModule: pageId }) => {
			const store = storesMap.get(pages[pageId].name);

			if (store) {
				this.registerModule(['pages', pageId], store);

				_.assign(state.pages[pageId], pages[pageId]);
			} else {
				console.error(`Unknown store key: ${state.pages[pageId].name}`);
			}
		});
	},
};
